import React from 'react';

import { flagStyles } from '../settings';

const SvgPR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4320px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPR;
